@if (recurrence().seperationCount; as seperationCount) {
  @if (seperationCount > 1) {
    every
  }
}
<span class="font-bold">
  {{ frequencyLabel() }}
</span>
@if (runTime(); as runTimeValue) {
  &#64;
  <span class="font-bold">{{ runTimeValue | timeFormat }}</span>
}
@if (recurrence().endingType === 'on') {
  <span class="font-bold">
    until {{ recurrence().endingDate | moment | amDateFormat: dateFormat }}
  </span>
} @else if (recurrence().endingType === 'after') {
  until
  <span class="font-bold">{{ recurrence().occurrenceCount }} occurrences</span>
}
